module.exports = __webpack_public_path__ + "static/img/service4.0a9d5e33.png";